import React from 'react';
import MenuItem from 'components/MenuItem';
import messages from 'containers/EpargnDashboard/messages';
import { injectIntl, IntlShape } from 'react-intl';
import PAGES from 'routes/pages';
import { translate } from 'helpers/intl';
import { EVENT_CATEGORIES } from 'helpers/GATracking';

const ActionButtons = (props: {
  intl: IntlShape;
  setDetailsPageBreadcrumbsPath: Function;
}) => (
  <>
    <MenuItem
      setDetailsPageBreadcrumbsPath={props.setDetailsPageBreadcrumbsPath}
      openServices={() => {}}
      items={[
        {
          title: translate({ ...messages.releve_situation }, props),
          icon: 'reportEpargn',
          path: PAGES.EPARGN_DETAILS,
          openModalServices: false,
          BreadcrumbsPath: [
            { name: 'epargn', route: PAGES.EPARGN_DASHBOARD },
            { name: 'mesReleveDeSituation' },
          ],
          category: EVENT_CATEGORIES.EPARGN_ACCUEIL,
          label: 'AG_Mes relevés de situation',
        },
        {
          title: translate({ ...messages.contracts }, props),
          icon: 'contractsEpargn',
          path: PAGES.EPARGN_DETAILS,
          openModalServices: false,
          BreadcrumbsPath: [
            { name: 'epargn', route: PAGES.EPARGN_DASHBOARD },
            { name: 'mesContrats' },
          ],
          category: EVENT_CATEGORIES.EPARGN_ACCUEIL,
          label: 'AG_Mes contrats',
        },
      ]}
    />
  </>
);

export default injectIntl(ActionButtons);
